import { Component, OnInit } from '@angular/core';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import * as XLSX from 'xlsx'; 
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { DecimalPipe } from '@angular/common';
import { NbThemeService } from '@nebular/theme';
import { FixedAssetService } from '../../shared/services/fixed-asset.service';

@Component({
  selector: 'ngx-fixed-asset-report',
  templateUrl: './fixed-asset-report.component.html',
  styleUrls: ['./fixed-asset-report.component.scss']
})
export class FixedAssetReportComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>

  location =null;
  isDark: boolean = false;

  assetList : any[]=[];
  filteredAssetList : any[]=[];


  locationList =[
    {value : 'ROOM-101'},
    {value : 'ROOM-102'},
    {value : 'ROOM-103'},
    {value : 'ROOM-104'},
    {value : 'ROOM-105'},
    {value : 'ROOM-106'},
    {value : 'ROOM-201'},
    {value : 'ROOM-202'},
    {value : 'ROOM-203'},
    {value : 'ROOM-204'},
    {value : 'ROOM-205'},
    {value : 'ROOM-206'},
    {value : 'ROOM-ARALIYA'},
    {value : 'ROOM-KING'},
    {value : 'ROOM-NELUM'},
    {value : 'ROOM-OLU'},
    {value : 'OFFICE'},
    {value : 'KITCHEN'},
    {value : 'SWIMMING POOL'},
    {value : 'STORE'},

    {value : 'RECEPTION'},
    {value : 'BAR'},
    {value : 'KAYAK HOLDER'},
    {value : 'BOAT ITEM'},
    {value : 'UNDER THE WATER TANK'},
    {value : 'ROOF TOP SOLA'},
    {value : 'ENGINE ITEM'},
    {value : 'BEHIND THE BAR'},
    {value : 'OVER THE WATER TANK'},
    {value : 'GENERATOR'},
    {value : 'BIKE ITEM'},
    {value : 'GAS STORE'},
    {value : 'CHEMICAL STORE'},
    {value : 'STAFF ROOM 1'},
    {value : 'STAFF ROOM 2'},
    {value : 'WATER PUMP'},
    {value : 'CHAIRS PLASTIC'},
    {value : 'CHAIRS WOODEN'},
    {value : 'CUTLERY'},
    {value : 'LINEN'},
    {value : 'PLATE'},
    {value : 'GLASS'},
  

  ];

  constructor(
              private fixedAssetService : FixedAssetService, 
              private router : Router, 
              private themeService: NbThemeService,
              private decimalPipe : DecimalPipe
             )
              {
                this.datepickerConfig = Object.assign({},
                {   
                  showWeekNumbers:false,
                  dateInputFormat : 'YYYY-MM-DD'
                });

              }

    ngOnInit() {
      this.getAllExpBreakup();    
      
      this.themeService.onThemeChange()
      .subscribe(themeName =>{
       this.isDark  = themeName.name ==='dark' ? true : false;
     });
    }

 
    getAllExpBreakup(){
    this.fixedAssetService.getAll()
     .subscribe(
        (data) => {
                  this.assetList = data;  
                  this.filteredAssetList =   this.assetList;                           
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });          
     }

     getTotal(){
      return this.filteredAssetList.map(totalBal=>totalBal.Cost).reduce((acc,value)=>acc + +value,0);
    }
    

      viewBtnClicked(){
        if(this.location){      
            this.filteredAssetList = this.assetList.filter(data => {             
                  return data.Location.toLowerCase().indexOf(this.location.trim().toLowerCase()) !==-1;
                  });
        }
        

      }


     clearBtnClicked(){
      this.location  = null;
      this.filteredAssetList =   this.assetList;    
     }

     savePDF(action){

      const documentDefinition = { 
        pageSize: 'A4',
        pageOrientation: 'landscape',

        content: [   
          { text: 'Fixed Asset Report', style: 'reportHeader' }, 
          { text: this.location  ? `Location : ${this.location}` : '',alignment: 'center',margin: [0,5,0,5] }, 
           
                     
          {  
            table: {  
                headerRows: 1,  
                widths: ['auto', 'auto', '*','auto', 'auto', 'auto','auto', 'auto','auto', 'auto'],  
                body: [  
                  ['AssetCode', 'AssetName','Category',  'Location', 'PurchaseDate', 'Cost', 'Init.Qty','UsefulQty','Dis.Qty','CreatedBy'],
                  ...this.filteredAssetList.map(p => ([p.AssetCode,p.AssetName, p.Category,p.Location,moment(p.PurchaseDate).format("YYYY-MM-DD"), {text : this.transformNumberFormat(p.Cost), alignment: 'right'  },{text: p.Qty ,alignment: 'center'},{text: p.UsefulQty ,alignment: 'center'},{text: p.DisposalQty ,alignment: 'center'},p.CreatedBy])),  
                  [ { text: 'Total Value of Assets : ', bold: true, colSpan: 5 }, {},{},{},{}, { text :  this.transformNumberFormat(this.getTotal()),alignment: 'right', bold : true },{},{},{},{}  ]  
                ]           
          }
        }
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 10],
              alignment: 'center',             
          }  
        }  
       };

        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
     }

     exportexcel(): void 
     {
        /* table id is passed over here */   
        let element = document.getElementById('expReport'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
        /* save to file */
        XLSX.writeFile(wb, 'Fixed Asset Report.xlsx');
       
     }

     transformNumberFormat(number) {
      return this.decimalPipe.transform(number,'1.2-2');
   }


}
